<div class="dialog-container">
  <header class="dialog-header">
    <div>
      <h2>Upload TAPSCAN File</h2>
      <p class="station-line">{{ data.station.call_sign }} · {{ data.station.name }} · {{ data.station.dial_position }} FM</p>
    </div>
    <button type="button" class="icon-close" (click)="onCancel()" [disabled]="uploading" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="dialog-body">
    <p class="hint">
      Upload a TAPSCAN CSV to update ratings. Existing ratings for the selected day type will be overwritten.
    </p>

    <div class="field">
      <span class="field-label">CSV file</span>
      <input
        #fileInput
        type="file"
        accept=".csv,text/csv"
        class="file-input"
        id="tapscan-file-input"
        (change)="onFileSelected($event)">

      <label
        for="tapscan-file-input"
        class="dropzone"
        [class.dropzone--active]="dragOver"
        [class.dropzone--filled]="!!selectedFile"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)">
        <mat-icon class="dropzone-icon">{{ selectedFile ? 'description' : 'upload_file' }}</mat-icon>
        <ng-container *ngIf="!selectedFile; else fileChosen">
          <span class="dropzone-title">Choose CSV file</span>
          <span class="dropzone-sub">or drag and drop here</span>
        </ng-container>
        <ng-template #fileChosen>
          <span class="dropzone-title">{{ selectedFile?.name }}</span>
          <span class="dropzone-sub">{{ formatFileSize(selectedFile!.size) }} · Click to change</span>
        </ng-template>
      </label>

      <button
        *ngIf="selectedFile"
        type="button"
        class="btn-clear"
        (click)="clearFile(fileInput)"
        [disabled]="uploading">
        Remove file
      </button>
    </div>

    <div class="field" *ngIf="selectedFile">
      <span class="field-label">File type</span>
      <div class="type-toggle" role="group" aria-label="TAPSCAN file type">
        <button
          type="button"
          class="type-option"
          [class.active]="fileType === 'MF'"
          (click)="fileType = 'MF'"
          [disabled]="uploading">
          <strong>Monday – Friday</strong>
          <small>Weekday ratings</small>
        </button>
        <button
          type="button"
          class="type-option"
          [class.active]="fileType === 'SS'"
          (click)="fileType = 'SS'"
          [disabled]="uploading">
          <strong>Saturday – Sunday</strong>
          <small>Weekend ratings</small>
        </button>
      </div>
    </div>
  </div>

  <footer class="dialog-footer">
    <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="uploading">Cancel</button>
    <button type="button" class="btn-submit" (click)="onUpload()" [disabled]="!selectedFile || uploading">
      <mat-spinner *ngIf="uploading" diameter="18"></mat-spinner>
      <mat-icon *ngIf="!uploading" aria-hidden="true">cloud_upload</mat-icon>
      <span>{{ uploading ? 'Uploading…' : 'Upload File' }}</span>
    </button>
  </footer>
</div>
